// Rules-only constants for Cricket-style Killer, a Killer variant. The
// actual play (number assignment, hit resolution, elimination) lives in
// controller.js - this just fixes the choices the setup screen offers and
// how a finished game is ranked.

export const LIVES_OPTIONS = [3, 5, 7];
export const DEFAULT_LIVES = 5;

export const INCLUDE_BULL_OPTIONS = ['yes', 'no'];
export const DEFAULT_INCLUDE_BULL = 'no';

// Ranked by lives remaining at the moment the game ended - the winner is
// whoever's still standing (some lives left); everyone else by how close
// they got before being eliminated (0, tied, in elimination order isn't
// tracked so ties just keep player order).
function rankPlayers(players, scores) {
    return players.slice().sort((a, b) => scores[b] - scores[a]);
}

export default {
    id: 'cricket-style-killer',
    name: 'Cricket-style Killer',
    description: "Claim a number each, then build your lives by hitting your own number - reach full lives and you become a Killer. A Killer's darts cost lives instead of adding them (even hitting your own number costs a life and strips your Killer status), while a single dart on your own number can make you one instantly if it fills the rest of your lives in one go. Last player standing wins.",
    minPlayers: 2,
    // Declares this game's setup-screen options (see app.js's
    // renderConfigRows/getConfigRowValues). The "killer-lives" row id is
    // shared with standard Killer's own definition (and only that one -
    // namespaced so it can't accidentally collide with some other game's
    // unrelated "lives" concept later) - a row id doubles as its storage
    // key, so both games remember one shared lives preference.
    configRows: [
        {
            id: 'killer-lives',
            label: 'Lives per player',
            default: String(DEFAULT_LIVES),
            numeric: true,
            options: LIVES_OPTIONS.map(value => ({ value: String(value), label: String(value) }))
        },
        // Shares its "killer-include-bull" row id with standard Killer's
        // own definition, same as "killer-lives" above - both games
        // remember one shared choice for it.
        {
            id: 'killer-include-bull',
            label: 'Include Bull/Bullseye',
            default: DEFAULT_INCLUDE_BULL,
            options: INCLUDE_BULL_OPTIONS.map(value => ({
                value,
                label: value === 'yes' ? 'Yes' : 'No',
                description: 'Should the bull/bullseye be eligible when choosing numbers?'
            }))
        }
    ],
    rankPlayers
};
